import React from 'react';
import Grid from '@mui/material/Grid';
import { ReactComponent as EmptyState } from '../img/emptyState.svg';

function EmptyError(props: { title: string, description: string, origin?: string }) {
  //ORIGIN: props originada do editor rico RealTimeQuillEditor.tsx (origin = 'quill')

  return (
    <>
      <EmptyState style={{ marginTop: '15px', maxWidth: props?.origin === 'quill' ? '100%' : 'none' }} />
      <Grid style={{ width: props?.origin === 'quill' ? '90vw' : 'none', maxWidth: props?.origin === 'quill' ? '90%' : 'none', textAlign: 'center', margin: props?.origin === 'quill' ? '0 auto' : 'none' }}>
        <h2>{props.title ? props.title : "Ops!"}</h2>
      </Grid>
      <Grid style={{ width: props?.origin === 'quill' ? '90vw' : 'none', maxWidth: props?.origin === 'quill' ? '90%' : 'none', overflowX: 'hidden', margin: props?.origin === 'quill' ? '0 auto' : 'none', textAlign: 'center' }}>
        {props.description ? props.description : "Não existem dados a apresentar."}
      </Grid>
    </>
  );

}

export default EmptyError;


// <EmptyState style={{ marginTop: '15px' }} />
//       <h2>{props.title ? props.title : "Ops!"}</h2>
//       <Grid>{props.description ? props.description : "Não existem dados a apresentar."}</Grid>
